import React from 'react';
import {
    Grid,
    Typography,
    withStyles
} from 'material-ui';
import ReservationStatusRender from './ReservationStatusRender';
import DynIcon from '../Utils/DynIcon';

const styles = theme => ({
    locatorTitle: {
        color: 'var(--primary-text-color)',
        fontSize: '16px',
        fontWeight: 300,
    }
});

class ReservationBigButton extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { classes, t, reservation } = this.props;
        const { cancellationInsurance } = reservation && reservation.hotel ? reservation.hotel : {};
        return (
            <table width="100%">
                <tr>
                    <td>
                        <Typography style={{ textTransform: 'uppercase' }} className={classes.locatorTitle}>{t('COMMON.' + reservation.type.toUpperCase())}</Typography>
                    </td>
                    <td>
                        <DynIcon
                            icon={reservation.type}
                            style={{ color: 'var(--primary-text-color)', float: 'right' }}
                        />
                        {reservation.transfer && reservation.transfer.flightinformation.airport && reservation.transfer.flightinformation.airport !== '' ?
                            <DynIcon icon="Flight" style={{ color: 'var(--primary-text-color)', width: '15px', height: '15px', float: 'right' }} /> :
                            ''}
                    </td>
                </tr>
                <tr><td colSpan="2"><hr style={{ margin: '0px' }} /></td></tr>
                <tr>
                    <td>
                        <Typography className={classes.locatorTitle}>
                            {t('BOOKING_DETAIL.BOOKING_LOCATOR')}
                        </Typography>
                    </td>
                    <td style={{ textAlign: 'right' }}>
                        <Typography className={classes.locatorTitle}>
                            {reservation.olympiaLocator}
                        </Typography>
                    </td>
                    {cancellationInsurance && cancellationInsurance.active === 'SI' &&
                        <td style={{ textAlign: 'right' }}>
                            <Typography >
                                {t('BOOKINGS.CANCELLATION_INSURANCE_INCLUDED')}
                                <a href="../../../assets/Clausulas SEGURO ANULACION_ESP.pdf" target='_blank'>
                                    {t('BOOKINGS.SHOW_CONDITIONS')}
                                </a>
                            </Typography>
                        </td>
                    }
                </tr>
                <tr>
                    <td>
                        <Typography className={classes.locatorTitle}>
                            {t('BOOKING_DETAIL.STATE')}
                        </Typography>
                    </td>
                    <td>
                        <ReservationStatusRender
                            divPadding='5px'
                            divWidth='18px'
                            divHeight='16px'
                            size='16px'
                            reservation={reservation}
                        />
                    </td>
                </tr>
            </table>
        );
    }
}
export default (withStyles(styles)(ReservationBigButton));


// WEBPACK FOOTER //
// ./src/components/Reservation/ReservationBigButton.js